import {
    IDX_RPT_QUALITY_REPORT,
    IDX_RPT_QUALITY_REPORT_SUCCESS,
    IDX_RPT_QUALITY_REPORT_ERROR,
    IDX_RPT_QUALITY_SUPPLIER,
    IDX_RPT_QUALITY_SUPPLIER_SUCCESS,
    IDX_RPT_QUALITY_SUPPLIER_ERROR,
    IDX_RPT_QUALITY_PRODUCT,
    IDX_RPT_QUALITY_PRODUCT_SUCCESS,
    IDX_RPT_QUALITY_PRODUCT_ERROR,
    IDX_RPT_QUALITY_MTX_QA_MED,
    IDX_RPT_QUALITY_MTX_QA_MED_SUCCESS,
    IDX_RPT_QUALITY_MTX_QA_MED_ERROR,
    IDX_RPT_QUALITY_SEARCH_CHANGE,
    IDX_RPT_QUALITY_MTX_QA_MED_PAGE_SET,
    IDX_RPT_QUALITY_SUPPLIER_MMQ,
    IDX_RPT_QUALITY_SUPPLIER_MMQ_SUCCESS,
    IDX_RPT_QUALITY_SUPPLIER_MMQ_ERROR,
    IDX_RPT_QUALITY_PRODUCT_MMQ,
    IDX_RPT_QUALITY_PRODUCT_MMQ_SUCCESS,
    IDX_RPT_QUALITY_PRODUCT_MMQ_ERROR,
    IDX_RPT_QUALITY_MTX_QA_MMQ,
    IDX_RPT_QUALITY_MTX_QA_MMQ_SUCCESS,
    IDX_RPT_QUALITY_MTX_QA_MMQ_ERROR,
    IDX_RPT_QUALITY_MTX_QA_MMQ_SEARCH_CHANGE,
    IDX_RPT_QUALITY_MTX_QA_MMQ_PAGE_SET
} from "../../actions";

const INIT_STATE = {
    loading: false,
    reportlist: {
        loading: false,
        data: []
    },
    supplier: {
        loading: false,
        data: []
    },
    product: {
        loading: false,
        data: []
    },
    mtxqamed: {
        loading: false,
        data: [],
        page: {
            current: 1,
            rows: 10
        }
    },
    suppliermmq: {
        loading: false,
        data: []
    },
    productmmq: {
        loading: false,
        data: []
    },
    mtxqammq: {
        loading: false,
        data: [],
        page: {
            current: 1,
            rows: 10
        }
    },

    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            supplier: '',
            product: '',
            statusrs: '',
            statusbpm: '',
            statushl:''
        },
        value: {
            supplier: '',
            product: '',
            statusrs: '',
            statusbpm: '',
            statushl: ''
        }
    },
    searchmmq: {
        modal: false,
        init: true,
        data: {
            supplier: '',
            product: '',
            statusrs: '',
            statusbpm: '',
            statushl: ''
        },
        value: {
            supplier: '',
            product: '',
            statusrs: '',
            statusbpm: '',
            statushl: ''
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case IDX_RPT_QUALITY_REPORT:
            return {
                ...state,
                loading: true,
                reportlist: {
                    ...state.reportlist
                }
            }
        case IDX_RPT_QUALITY_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                reportlist: {
                    ...state.reportlist,
                    ...action.payload
                }
            }
        case IDX_RPT_QUALITY_REPORT_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case IDX_RPT_QUALITY_SUPPLIER:
            return {
                ...state,
                loading: true,
                supplier: {
                    ...state.supplier
                }
            }
        case IDX_RPT_QUALITY_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                supplier: {
                    ...state.supplier,
                    ...action.payload
                }
            }
        case IDX_RPT_QUALITY_SUPPLIER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case IDX_RPT_QUALITY_PRODUCT:
            return {
                ...state,
                loading: true,
                product: {
                    ...state.product
                }
            }
        case IDX_RPT_QUALITY_PRODUCT_SUCCESS:
            return {
                ...state,
                loading: false,
                product: {
                    ...state.product,
                    ...action.payload
                }
            }
        case IDX_RPT_QUALITY_PRODUCT_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case IDX_RPT_QUALITY_MTX_QA_MED:
            return {
                ...state,
                loading: true,
                mtxqamed: {
                    ...state.mtxqamed
                }
            }

        case IDX_RPT_QUALITY_MTX_QA_MED_SUCCESS:
            return {
                ...state,
                loading: false,
                mtxqamed: {
                    ...state.mtxqamed,
                    ...action.payload
                }
            }
        case IDX_RPT_QUALITY_MTX_QA_MED_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case IDX_RPT_QUALITY_MTX_QA_MED_PAGE_SET:
            return {
                ...state,
                mtxqamed: {
                    ...state.mtxqamed,
                    page: {
                        ...state.mtxqamed.page,
                        ...action.payload,
                    }
                }
            }
        case IDX_RPT_QUALITY_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }

        case IDX_RPT_QUALITY_SUPPLIER_MMQ:
            return {
                ...state,
                loading: true,
                suppliermmq: {
                    ...state.suppliermmq
                }
            }
        case IDX_RPT_QUALITY_SUPPLIER_MMQ_SUCCESS:
            return {
                ...state,
                loading: false,
                suppliermmq: {
                    ...state.suppliermmq,
                    ...action.payload
                }
            }
        case IDX_RPT_QUALITY_SUPPLIER_MMQ_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case IDX_RPT_QUALITY_PRODUCT_MMQ:
            return {
                ...state,
                loading: true,
                productmmq: {
                    ...state.productmmq
                }
            }
        case IDX_RPT_QUALITY_PRODUCT_MMQ_SUCCESS:
            return {
                ...state,
                loading: false,
                productmmq: {
                    ...state.productmmq,
                    ...action.payload
                }
            }
        case IDX_RPT_QUALITY_PRODUCT_MMQ_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case IDX_RPT_QUALITY_MTX_QA_MMQ:
            return {
                ...state,
                loading: true,
                mtxqammq: {
                    ...state.mtxqammq
                }
            }

        case IDX_RPT_QUALITY_MTX_QA_MMQ_SUCCESS:
            return {
                ...state,
                loading: false,
                mtxqammq: {
                    ...state.mtxqammq,
                    ...action.payload
                }
            }
        case IDX_RPT_QUALITY_MTX_QA_MMQ_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case IDX_RPT_QUALITY_MTX_QA_MMQ_PAGE_SET:
            return {
                ...state,
                mtxqammq: {
                    ...state.mtxqammq,
                    page: {
                        ...state.mtxqammq.page,
                        ...action.payload,
                    }
                }
            }
        case IDX_RPT_QUALITY_MTX_QA_MMQ_SEARCH_CHANGE:
            return {
                ...state,
                searchmmq: {
                    ...state.searchmmq,
                    data: action.payload,
                }
            }

        default:
            return { ...state };
    }
};